var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.563 27.669a1.508 1.508 0 0 1-.006 2.125l-1.769 1.769a1.493 1.493 0 0 1-2.119 0l-6.231-6.231A1.5 1.5 0 0 1 21 24.269V23.25A12.935 12.935 0 0 1 13 26C5.819 26 0 20.181 0 13S5.819 0 13 0s13 5.819 13 13c0 3.019-1.025 5.794-2.75 8h1.019c.4 0 .781.156 1.063.438zM13 21c4.425 0 8-3.581 8-8 0-4.425-3.581-8-8-8-4.425 0-8 3.581-8 8 0 4.425 3.581 8 8 8z"}));
}

Search.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Search;

Search.default = Search;
